// API Configuration
const API_CONFIG = {
  // Base URL for API calls
  BASE_URL: process.env.REACT_APP_API_URL || 'https://etqanvision.com/api',
  
  // API Endpoints
  ENDPOINTS: {
    // Authentication
    LOGIN: '/login',
    
    // Contact Messages
    CONTACT_SUBMIT: '/contact',
    CONTACT_MESSAGES: '/contact-messages',
    CONTACT_STATUS: '/contact-messages/:id/status',
    
    // Consultation Requests
    CONSULTATION_SUBMIT: '/consultation',
    CONSULTATION_REQUESTS: '/consultation-requests',
    CONSULTATION_STATUS: '/consultation-requests/:id/status',
    
    // Languages
    LANGUAGES: '/languages',
    LANGUAGES_ACTIVE: '/languages/active',
    LANGUAGE_TOGGLE: '/languages/:code/toggle',
    
    // Dashboard Statistics
    DASHBOARD_STATS: '/dashboard/stats'
  },
  
  // Request Headers
  HEADERS: {
    'Content-Type': 'application/json',
  },
  
  // Authentication
  AUTH: {
    TOKEN_KEY: 'adminToken',
    USER_KEY: 'adminUser'
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem(API_CONFIG.AUTH.TOKEN_KEY);
  return {
    ...API_CONFIG.HEADERS,
    'Authorization': token ? `Bearer ${token}` : ''
  };
};

// Helper function to replace URL parameters
export const replaceUrlParams = (url, params) => {
  let finalUrl = url;
  Object.keys(params).forEach(key => {
    finalUrl = finalUrl.replace(`:${key}`, params[key]);
  });
  return finalUrl;
};

export default API_CONFIG;
